import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  input: {
    height: 86,
  },
}));

export default useStyles;
